<div class="sidebar" [class.collapsed]="collapsed">
  <!-- Logo Section -->
  <div class="logo-section">
    <div class="logo-container">
      <!-- Hamburger / collapse toggle -->
      @if (!collapsed) {
        <button class="sidebar-hamburger" type="button" (click)="onToggleSidebar()" aria-label="Toggle sidebar">
          <i class="fa-solid fa-bars"></i>
        </button>
      }
      @if (!collapsed) {
        <div class="logo-icon">
          <img
            src="https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/adoretheballoon/adoretheballoon-logo-v2-main.png"
            alt="Adore The Balloon" class="balloon-logo">
          </div>
        }
        @if (collapsed) {
          <div class="collapsed-logo" (click)="onToggleSidebar()" style="cursor: pointer;" aria-label="Expand sidebar">
            <img src="assets/images/poptheballon-favicon-32.png" alt="Adore The Balloon" class="balloon-logo">
          </div>
        }
      </div>
    </div>

    <!-- Navigation Menu -->
    <nav class="nav-menu">
      <ul class="nav-list">
        @for (item of menuItems; track item) {
          <li class="nav-item" [class.active]="isActive(item.route)"
            (click)="setTitle(item.label)">
            <a class="nav-link" [routerLink]="item.route" routerLinkActive="active" 
               [pTooltip]="item.label" [tooltipDisabled]="!collapsed" tooltipPosition="right">
              <i class="nav-icon" [class]="item.icon"></i>
              @if (!collapsed) {
                <span class="nav-label">{{ item.label }}</span>
              }
            </a>
          </li>
        }
      </ul>
    </nav>
  </div>